import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SelectPatientSample } from "../OfflineDb/IndexDbTranscSP";
import PatientsAutoComplete from "../CommonControlls/PatientsDropdown";
import { SyncConfig } from "../OfflineDb/ConfigDataSync";
import DropDown from "../CommonControlls/DropdownRendrer";

const mapStateToProps = (store) => {
    return store;
};

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings });
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading });
        },
    };
};
// const [field, setField] = useState("");

// const handleChange = (event) => {
//   setField(event.target.value);
// };

class PatientSample_Add extends Component {
    constructor(props) {
        super(props);
        this.state = {
            SampleDate: new Date(),
            FollowUpCase: false,
            patientId: 0,
            patients: [],
            patient: null,
            patientList: [],
            isNegativeResultBypass: false,
            sortField: "id",
            idsortOrder: "desc",
        };
    }

    HandleDateChange = (Field, date) => {
        this.setState({
            [Field]: date == null ? new Date() : date,
        });
    };
    HandlePatientChange = (val) => {
        this.setState({
            patient: val[0],
        });
    };

    render() {
        return (
            <div>
                <MainLayout />
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle="Add Patient Sample" />
                    <div class="content ">
                        <div class="card ">
                            <div class="card-body" style={{ padding: "3rem" }}>
                                <form onSubmit={this.SubmitForm} novalidate>
                                    <div class="row justify-content-end">
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Sample Id
                                                </label>
                                                <input
                                                    autocomplete="off"
                                                    type="text"
                                                    class="form-control"
                                                    id="SampleId"
                                                    placeholder="Please scan sample QR..."
                                                />
                                            </div>
                                            {this.props.UserAuthentication.UserInfo?.roleId == 3 && (
                                                <div class="formInput_Container ">
                                                    <label for="">
                                                        <span style={{ color: "red" }}>* </span>Facility
                                                        Type
                                                    </label>
                                                    <select
                                                        id="facilityType"
                                                        className="form-control"
                                                        onChange={(e) => {
                                                            this.setState({
                                                                facilityType: e.target.value,
                                                            });
                                                        }}
                                                    >
                                                        <option value="RHC/PPM">RHC/PPM</option>
                                                        <option value="BHU/GP">BHU/GP</option>
                                                    </select>
                                                </div>
                                            )}
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Patient Name
                                                </label>
                                                <input
                                                    autocomplete="off"
                                                    type="text"
                                                    class="form-control"
                                                    id="patientName"
                                                    placeholder="Enter patient name"
                                                    onChange={() => {
                                                        this.setState({
                                                            patientName: "",
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Enter Age
                                                </label>
                                                <input
                                                    class="form-control"
                                                    id="patientAge"
                                                    type="number"
                                                    placeholder="Enter patient age(digits)"
                                                    pattern="[0-9]+"
                                                />
                                            </div>
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Gender
                                                </label>
                                                <select id="patientGender" className="form-control">
                                                    <option value="0">Select Gender</option>
                                                    <option value="1">Male</option>
                                                    <option value="2">Female</option>
                                                    <option value="3">Other</option>
                                                </select>
                                            </div>
                                            <div class="formInput_Container">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Phone
                                                </label>
                                                <input
                                                    autocomplete="off"
                                                    pattern="[0][0-9]{10}"
                                                    type="number"
                                                    class="form-control"
                                                    id="patientContact"
                                                    placeholder="Enter patient phone - 03123456789"
                                                />
                                            </div>

                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Negative
                                                    Result Bypass
                                                </label>
                                                <select
                                                    id="isNegativeResultBypass"
                                                    className="form-control"
                                                >
                                                    <option value="3">Select</option>
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>
                                                </select>
                                            </div>
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Sample Status
                                                </label>
                                                <select
                                                    id="sampleStatus"
                                                    className="form-control"
                                                    onChange={this.SaveSampleStatus}
                                                >
                                                    <option value="Fasting/Morning">
                                                        Fasting/Morning
                                                    </option>
                                                    <option value="Random">Random</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Date Time
                                                </label>
                                                <DatePicker
                                                    selected={this.state.SampleDate}
                                                    onChange={(date) => {
                                                        this.HandleDateChange("SampleDate", date);
                                                    }}
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    timeInputLabel="Time:"
                                                    showTimeInput
                                                    todayButton="Today"
                                                    dateFormat="MMMM d, yyyy h:mm aa"
                                                />
                                            </div>
                                            {this.props.UserAuthentication.UserInfo?.roleId === 3 && (
                                                <div
                                                    class="formInput_Container "
                                                // hidden={this.state.RoleId !== 3}
                                                >
                                                    <label for="">
                                                        <span style={{ color: "red" }}>* </span>Facility
                                                        Name
                                                    </label>
                                                    <select
                                                        id="facilityName"
                                                        className="form-control"
                                                    // required={this.state.RoleId === 3}
                                                    >
                                                        {this.state.facilityType === "BHU/GP"
                                                            ? this.state.BHUList?.map((row) => (
                                                                <option key={row.id} value={row.id}>
                                                                    {row.name}
                                                                </option>
                                                            ))
                                                            : this.state.RHCList?.map((row) => (
                                                                <option key={row.id} value={row.id}>
                                                                    {row.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            )}

                                            <div class="formInput_Container ">
                                                <label for="">Refer By</label>
                                                <input
                                                    autocomplete="off"
                                                    type="text"
                                                    class="form-control"
                                                    id="referredBy"
                                                    placeholder="Refer By(optional)"
                                                />
                                            </div>
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>Select Age
                                                    Type
                                                </label>
                                                <select id="patientAgeType" className="form-control">
                                                    <option value="Year">Year</option>
                                                    <option value="Month">Month</option>
                                                </select>
                                            </div>
                                            <div class="formInput_Container ">
                                                <label for="">
                                                    <span style={{ color: "red" }}>* </span>CNIC/B-Form #
                                                </label>
                                                <input
                                                    class="form-control"
                                                    id="patientCnic"
                                                    type="number"
                                                    placeholder="Enter patient CNIC(digits without '-')"
                                                    pattern="[0-9]+"
                                                />
                                            </div>
                                            <div class="formInput_Container">
                                                <label for="">Address</label>
                                                <textarea
                                                    class="form-control"
                                                    id="patientAddress"
                                                    placeholder="Enter patient address"
                                                    rows="3"
                                                ></textarea>
                                            </div>

                                            <div className="d-flex col-md-8 justify-content-between mt-4">
                                                <div className="formInput_Container text-center ">
                                                    <label className="CheckBox_container ">
                                                        <span>Follow Up</span>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) =>
                                                                this.setState({
                                                                    FollowUpCase: e.target.checked,
                                                                })
                                                            }
                                                            checked={this.state.FollowUpCase}
                                                        />
                                                        <span className="CheckBox_checkmark"></span>
                                                    </label>
                                                </div>
                                                <div className="formInput_Container">
                                                    <div className="text-center d-flex">
                                                        <div>
                                                            <label className="CheckBox_container mr-3">
                                                                <span>No of Slides</span>
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <select
                                                                id="noOfSlides"
                                                                className="form-control"
                                                                style={{ minHeight: "0px", minWidth: "55px" }}
                                                            >
                                                                <option value="1">1</option>
                                                                <option value="2">2</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form_footer formInput_Container justify-content-end">
                                            <button
                                                type="submit"
                                                id="Form_SaveBtn"
                                                class="btn btn_style1"
                                            >
                                                Save
                                            </button>
                                            <Link to="/Patient_Samples">
                                                <button
                                                    type="button"
                                                    id="Form_CancelBtn"
                                                    class="btn btn_style3"
                                                >
                                                    Cancel
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login");
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_PatientSamples");
        // setInterval(() => {
        //   this.SelectScannedSample();
        // }, 8000);

        // Common.Ajax(
        //   this.props.UserAuthentication.AuthToken,
        //   "GET",
        //   false,
        //   Common.APILinks.SelectAll_Patients,
        //   { sortField: "id", sortOrder: "ase" },
        //   (resp) => {
        //     this.setState({ patients: resp.data });
        //   }
        // );
        this.SelectHCF();
    }

    SubmitForm = (e) => {
        e.preventDefault();
        if ($("#SampleId").val() == "" || $("#SampleId").val() == null) {
            this.props.ShowAlert({
                Type: 0,
                Msg: "Please sacn sample QR code to add sample",
            });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }

        if ($("#patientCnic").val() == "" || $("#patientCnic").val() == null) {
            this.props.ShowAlert({
                Type: 0,
                Msg: "Please Correct the Patient CNIC",
            });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }

        if (
            $("#patientContact").val() == "" ||
            $("#patientContact").val() == null
        ) {
            this.props.ShowAlert({
                Type: 0,
                Msg: "Please Correct the Patient Phone No",
            });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }
        if ($("#patientAge").val() == "" || $("#patientAge").val() == null) {
            this.props.ShowAlert({
                Type: 0,
                Msg: "Please Correct the Patient Age",
            });
            setTimeout(function () {
                $("#Alertmsgbtn").click();
            }, 50);
            return;
        }
        // if (this.state.patient == null) {
        //   this.props.ShowAlert({ Type: 0, Msg: "Please select patient" });
        //   setTimeout(function () {
        //     $("#Alertmsgbtn").click();
        //   }, 50);
        //   return;
        // }
        this.props.ShowLoader({ Isloading: true });
        // var Parameters = {
        //   facilityName: $("#facilityName").val(),
        //   facilityType: $("#facilityType").val(),
        // };
        var Parameters = {
            id: 0,
            sampleId: $("#SampleId").val(),
            name: $("#patientName").val(),
            phone: $("#patientContact").val(),
            Age: $("#patientAge").val(),
            Gender: $("#patientGender").val(),
            CNIC: $("#patientCnic").val(),
            Address: $("#patientAddress").val(),
            roleId: this.props.UserAuthentication.UserInfo?.roleId,
            isfollowUpCase: this.state.FollowUpCase,
            isNegativeResultBypass: this.state.isNegativeResultBypass,
            noOfSlides: parseInt($("#noOfSlides").val()),
            referredBy: $("#referredBy").val(),
            age_type: $("#patientAgeType").val(),
            //sampleDateTime: Common.ConvertToUtcDateTime(this.state.SampleDate),

            sampleStatus: $("#sampleStatus").val(),
        };

        if (this.props.UserAuthentication.UserInfo?.roleId == 1) {
        }
        if (this.props.UserAuthentication.UserInfo?.roleId == 3) {
            Parameters.xpertSiteId = this.props.UserAuthentication.UserInfo?.xpertSiteId;
            Parameters.is_submittedfrom = "submittedfromxpert";
            Parameters.hcfId = $("#facilityName").val();
        }
        if (
            this.props.UserAuthentication.UserInfo?.roleId == 6 ||
            this.props.UserAuthentication.UserInfo?.roleId == 7
        ) {
            Parameters.hcfId = this.props.UserAuthentication.UserInfo?.hcfId;
        }

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.Submit_PatientSample_New,
            Parameters,
            (resp) => {
                if (resp.status) {
                    SyncConfig(
                        () => {
                            this.ResetForm();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
                            setTimeout(() => {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        },
                        () => {
                            // e.target.reset();
                            this.ResetForm();
                            this.props.ShowLoader({ Isloading: false });
                            this.props.ShowAlert({
                                Type: 0,
                                Msg: "Error in sync, please reload the page",
                            });
                            setTimeout(function () {
                                $("#Alertmsgbtn").click();
                            }, 50);
                        }
                    );
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(() => {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    SaveSampleStatus = () => {
        const sample_id = $("#SampleId").val();
        const sampleStatus = $("#sampleStatus").val();
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "POST",
            false,
            Common.BaseUrlAPI +
            `/api/PatientSamples/UpdateSampleStatus?sample_id=${sample_id}&sampleStatus=${sampleStatus}`,
            {},
            (resp) => {
                if (resp.status) {

                    $("#ChangeSampleStatusModal_btn").click();
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };
    SelectHCF = () => {
        this.setState({ HCFLoader: true });
        Common.Ajax(
            this.props.UserAuthentication?.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_HCF,
            {},
            (data) => {
                var BHUList = [];
                var RHCList = [];
                for (var i = 0; i < data.data.length; i++) {
                    if (data.data[i].typeId === 1) {
                        BHUList.push(data.data[i]);
                    } else {
                        RHCList.push(data.data[i]);
                    }
                }

                const TempBHU = BHUList;
                const filteredBHU = TempBHU.filter(
                    (item) =>
                        +item.districtId ===
                        +this.props.UserAuthentication.UserInfo?.addressDistrictId &&
                        +item.tehsilId ===
                        +this.props.UserAuthentication.UserInfo?.addressTehsilId &&
                        +item.provinceId ===
                        +this.props.UserAuthentication.UserInfo?.addressProvinceId
                );

                const TempRHC = RHCList;
                const filteredRHC = TempRHC.filter(
                    (item) =>
                        +item.districtId ===
                        +this.props.UserAuthentication.UserInfo?.addressDistrictId &&
                        +item.tehsilId ===
                        +this.props.UserAuthentication.UserInfo?.addressTehsilId &&
                        +item.provinceId ===
                        +this.props.UserAuthentication.UserInfo?.addressProvinceId
                );

                this.setState({
                    HCFList: data.data,
                    BHUList: filteredBHU,
                    RHCList: filteredRHC,
                    HCFLoader: false,
                });
            },
            (error) => {
                this.setState({ HCFLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ResetForm = () => {
        $("#SampleId").val("");
        $("#patientCnic").val("");
        $("#patientName").val("");
        $("#patientContact").val("");
        $("#patientAge").val("");
        $("#patientGender").val("0");
        $("#patientAddress").val("");
        $("#referredBy").val("");
        $("#patientAgeType").val("Year");
        $("#sampleStatus").val("Fasting/Morning");
        $("#isNegativeResultBypass").val("3");
        this.setState({
            SampleDate: new Date(),
            patient: null,
            // isNegativeResultBypass: false,
            FollowUpCase: false,
        });
    };
    SelectScannedSample = () => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Select_ScannedSample,
            {},
            (resp) => {
                if (resp.status == true && resp.sampleId != 0) {
                    $("#SampleId").val(resp.sampleId);
                }
            },
            (error) => {
                // this.props.ShowLoader({Isloading:false})
                // this.props.ShowAlert({Type:0,Msg:"Something went wronge, please try again."})
                // setTimeout(()=>{ $("#Alertmsgbtn").click()}, 50);
            }
        );
    };

    loadAllPatients = () => {
        var Parameters = {
            //pageSize: this.state.sizePerPage,
            //pageNumber: this.state.page,
            sortField: this.state.sortField,

            subrecipientId: this.state.SrId,
            PatientSampleId: $("#sampleId").val(),
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Patients,
            Parameters,
            (data) => {
                this.setState({
                    patientList: data.data,
                });
            },
            (error) => {
                // this.props.ShowAlert({Type: 0, Msg: error})
                // setTimeout(function () {
                //     $("#Alertmsgbtn").click()
                // }, 50);
            }
        );
    };

    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState(
            {
                [fieldId]: value,
                // isSaveSearch: this.state.isSearchChanged ? true : false
            },
            () => { }
        );
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientSample_Add);
